/*
  Dulora spec chips — mobile tap-to-expand toggle.

  Lives as an external asset (NOT inline in dulora-spec-chips.liquid) because the
  product-page "You may also like" (<product-recommendations>) and "Recently viewed"
  (<recently-viewed>) carousels fetch their markup and inject it via innerHTML.
  Scripts inserted through innerHTML never execute, so an inline toggle script runs
  only on server-rendered collection/search cards and is dead on the product-page
  carousels. Loading the logic as a deferred asset means it always runs, and its
  MutationObserver picks up the chips once the carousels inject their content.

  Mobile-only (<768px). Self-dedupes per container via dataset.initialized.
*/
(function () {
  function initMobileChipsToggle() {
    if (window.innerWidth >= 768) return;

    document.querySelectorAll('.pcard-chips').forEach(function (container) {
      if (container.dataset.initialized === 'true') return;
      container.dataset.initialized = 'true';

      function handleGroupToggle(event) {
        const clickedChip = event.target.closest('.chip[data-mobile-toggle="true"]');
        if (!clickedChip) return;

        // Prevent background links from tracking tap initialization actions
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const checkExpanded = clickedChip.classList.contains('is-expanded');

        // Close all open chips sitewide before expanding this group
        document.querySelectorAll('.chip[data-mobile-toggle="true"]').forEach(function (item) {
          item.classList.remove('is-expanded');
        });

        // Toggle ALL chips inside this specific product card container simultaneously
        if (!checkExpanded) {
          container.querySelectorAll('.chip[data-mobile-toggle="true"]').forEach(function (item) {
            item.classList.add('is-expanded');
          });
        }
      }

      // Attach layout capture listeners to intercept interactions instantly
      container.addEventListener('touchstart', handleGroupToggle, { capture: true, passive: false });
      container.addEventListener('click', handleGroupToggle, { capture: true });
    });
  }

  // Initialize logic loop sequences
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileChipsToggle);
  } else {
    initMobileChipsToggle();
  }

  // Monitor modern dynamic collection loads / slider components (covers the
  // async-injected product-page recommendation + recently-viewed carousels)
  const observer = new MutationObserver(initMobileChipsToggle);
  observer.observe(document.body, { childList: true, subtree: true });

  // Collapse active open chip nodes cleanly if user taps empty whitespace
  document.addEventListener('touchstart', function (event) {
    if (!event.target.closest('.chip[data-mobile-toggle="true"]')) {
      document.querySelectorAll('.chip[data-mobile-toggle="true"]').forEach(function (item) {
        item.classList.remove('is-expanded');
      });
    }
  }, { capture: true });
})();
